import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { localePath } from '../../core/utils/locale-path';

// Impure on purpose: its input is a constant string, so a pure pipe would not re-run when the
// language changes.
@Pipe({ name: 'localePath', pure: false })
export class LocalePathPipe implements PipeTransform {
  private readonly language = inject(LanguageService);

  transform(path: string): string {
    return localePath(path, this.language.lang());
  }
}
